<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 150 150" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round">
    <path d="M115,73.5c0,21.82-17.68,39.5-39.5,39.5s-39.5-17.68-39.5-39.5,17.68-39.5,39.5-39.5,39.5,17.68,39.5,39.5Zm-28.85-14.77l-21.3,29.54m0-29.54l21.3,29.54" />
  </svg>
</template>
